<template>
  <div class="p-0 col">
    <!-- Top MPE editor section -->
    <div class="mb-2 posts-settings">
      <div class="edit-section post-behaviour-editor mb-2">

        <!-- Editor's toolbar -->
        <div
          v-if="!basic && false"
          class="flexed mb-3">

          <div class="campaign-manipulators">

            <button
              v-b-tooltip.hover :title="$t('Button.duplicate')"
              class="btn top-action-btn"
              @click="duplicateMpe">

              <icon name="copy" />
            </button>
          </div>
        </div>

        <!-- MPE's deployment options -->
        <div class="flexed mb-1">
          <div class="campaign-group flexed">
            <div class="campaign-label ">
              {{ getCampaignLabel }}
            </div>
          </div>
        </div>
        <div class="flexed mb-3">
          <div v-if="!published" class="w-100">
            <input-date-time
              variant="standardInput"
              inputName="startsAt"
              :inputLabel="$t('MpeEditor.DateTime.postAt.label')"
              :inputValue="publishAt"
              @fieldUpdate="updateMpeScheduale"
              smaller
              slimmer
              :inputPlaceholder="$t('Datetime.postAt')"
              :minDateTime="getCurrentDateTIme" />

          </div>

          <div class="w-100">
            <input-date-time
              variant="standardInput"
              inputName="expiresAt"
              :inputLabel="$t('MpeEditor.DateTime.expiresAt.label')"
              :inputValue="removeAt"
              @fieldUpdate="updateMpeScheduale"
              smaller
              slimmer
              :inputPlaceholder="$t('Datetime.removeAt')"
              :minDateTime="getCurrentDateTIme" />

          </div>

          <div v-if="!basic && false">
            <form-checkbox
              class=" padded"
              :items="afterCampaignCheckboxes"
              @fieldUpdate="updateAfterEvent" />

          </div>

        </div>
        

        <!-- MPE's advertisable -->
        <!-- <div
          v-if="!basic"
          class="flexed d-none d-md-block">

          <div class="campaign-advertisable-label ">
            {{ advertisableLabel }}
          </div>

          <div class="campaign-advertisable-change ">
            <input-button
              variant="standardInput"
              :inputPlaceholder="getAdvertisableChangeLabel"
              smaller
              :btnStyle="getAdvertisableChangeStyle"
              @click="toggleRequestNewAdvertisable" />

          </div>
        </div> -->
      </div>
    </div>

    <!-- Slot for channel specific input -->
    <div :class="getEditSectionClass">
      <slot name="post-content"></slot>
    </div>

    <div class="mt-2 posts-settings clear">

      <!-- Bottom MPE editor section -->
      <div class="edit-section post-behaviour-editor">
        <!-- Final options -->
        <div class="mt-3">
          <div class="mpe-save-discard">
            <input-button
              variant="standardInput"
              btnStyle="remove-style"
              hollow
              @click="discardChanges"
              :inputPlaceholder="$t('Button.cancel')" />

            <input-button
              class="ml-3"
              variant="standardInput"
              btnStyle="ok-style"
              spinner
              @click="saveChanges"
              :dataLoading="saving"
              :dissabled="submitDisabled"
              :inputPlaceholder="$t('Button.save')" />

          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->

  <!-- Advertisable switcher -->
  <!-- <div
    v-if="requestingNewAdvertisable"
    class="advertisable-switcher col-12 col-md-6 d-none d-md-block">

    <div class="switcher-container">
      <post-list
        :limitSelection="1"
        selectable
        biggerBoxes
        scrollable
        :selected="getSelectedAdvertisableId"
        :displayList="getPaginatedList"
        :paginationInfo="getPaginationInfo"
        @requestPrevPage="requestPrevPage()"
        @requestNextPage="requestNextPage()"
        @selectionChanged="updateAdvertisable" />

    </div> -->

  </div>
</template>

<script>
import FormCheckbox from '@/components/standard/form/FormCheckbox'
import InputDateTime from '@/components/standard/input/InputDateTime'
import InputButton from '@/components/standard/input/InputButton'
import QImage from '@/components/standard/display/QImage'
import PostList from '@/components/standard/display/PostList'

import apiConnector from '@/mixins/apiConnector'
import advertisables from '@/mixins/pagination/providers/advertisables'
import moment from 'moment'

const uuidv1 = require('uuid/v1')

export default {
  data () {
    return {
      requestingNewAdvertisable: false,
      saving: false,
      postType: null,
      afterCampaignCheckboxes: [
        {
          name: 'Delete after',
          label: 'Delete after',
          value: 'del'
        }
      ]
    }
  },

  methods: {
    /**
     * Emit event duplication
     */
    duplicateMpe () {
      this.$emit('duplicateMpe', {duplicate: true})
    },

    /**
     * Emits event to save changes
     */
    saveChanges () {
      this.saving = true
      this.$emit('saveChanges', {discard: false})
    },

    /**
     * Emits event to discard changes
     */
    discardChanges () {
      this.$emit('discardChanges', {discard: true})
    },

    /**
     * Requests advertisable picker.
     */
    toggleRequestNewAdvertisable () {
      this.requestingNewAdvertisable = !this.requestingNewAdvertisable
    },

    /**
     * Emits event to update the mpe's schedule
     */
    updateMpeScheduale (e) {
      this.$emit('updateField', e)
    },

    /**
     * Emits an event on what to do with this MPE after the campaign
     */
    updateAfterEvent (e) {
      this.$emit('updateField', {field: 'deleteAfter', value: !e.changed.removed})
    },

    /**
     * Emits an event with what advertisable to replace the current MPE's event
     */
    updateAdvertisable (e) {
      this.$emit('updateField', {
        input: 'advertisable',
        value: e.advertisable.id
      })
    }
  },

  computed: {
    /**
     * Returnes a label for the change advertisable button
     */
    getAdvertisableChangeLabel () {
      return this.requestingNewAdvertisable ? 'Ok' : 'Button.changeProduct'
    },

    /**
     * Returnes a class for the change advertisable button
     */
    getAdvertisableChangeStyle () {
      return this.requestingNewAdvertisable ? 'remove-style' : 'ok-style'
    },

    getSelectedAdvertisableId () {
      return [
        (this.mpeStriped.mpeAdvertisable || {}).id
      ]
    },

    advertisableLabel () {
      if (!this.mpeStriped.mpeAdvertisable) {
        return '/'
      }
      return this.mpeStriped.mpeAdvertisable.label
    },

    getMpeParams () {
      return this.mpeStriped.params || {}
    },

    published () {
      return this.getMpeParams.status === 'published'
    },

    publishAt () {
      return this.getMpeParams.startsAt || null
    },

    removeAt () {
      return this.getMpeParams.expiresAt || null
    },

    getCampaignLabel () {
      return this.getMpeParams.campaignLabel || this.advertisableLabel
    },

    getEditSectionClass () {
      let base = `edit-section ${this.editSectionClasses}`
      return base
    },
    
    getCurrentDateTIme () {
      return moment().toISOString();
    }
  },

  props: {
    basic: {
      type: Boolean,
      required: false,
      default: false
    },

    editSectionClasses: {
      type: String,
      required: false,
      default: ''
    },
    mpeStriped: {
      type: Object,
      required: true,
      default: () => { return {} }
    },
    submitDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    'post-list': PostList,
    'q-image': QImage,
    'form-checkbox': FormCheckbox,
    'input-date-time': InputDateTime,
    'input-button': InputButton
  },

  mixins: [
    advertisables,
    apiConnector
  ]
}
</script>

<style scoped>
.top-action-btn {
  padding: 5px;
  margin: 0;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  border: 1px solid rgb(0, 0, 0, .3);
  text-align: right;
  float: right;
  margin-left: 5px;
}
.spaced-out {
  margin-left: 4px;
  margin-right: 4px;
}
.padded {
  padding-top: 12px;
}
.posts-settings {
  background-color: #FFFFFF;
  padding: 2px 0;
  /* border-radius: 10px; */
}
.posts-settings.clear {
  background-color: transparent;
}

.edit-section {
  background-color: #FFFFFF;
  padding: 10px 15px;
}
.posts-settings.clear .edit-section {
  background-color: transparent;
  padding: 0;
}

.flexed {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.advertisable-switcher {
  padding: 0 15px;
  margin: 10px 5px;
}

.mpe-save-discard {
  display: flex;
  justify-content: flex-end
}

@media (max-width: 768px) {
  .advertisable-switcher {
    padding: 0 15px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/standard/formatter/Base.vue?0a0b7432